import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

export const GetJobSubcontractor = async (workReqID, jobSubcontractorID, jobID, navigate) => {
  const accesstoken = getToken();
  if (accesstoken) {
    const queryParams = new URLSearchParams({
        workReqID,
        jobSubcontractorID: jobSubcontractorID || 0,
        jobID
    }).toString();
    try {
      const response = await fetch(`${dev_baseUrl}/JobSubcontractor/get?${queryParams}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
      });
      
      const data = await response.json();        

      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
          navigate(`/login`);
      } else if(response.ok && !data.isError ){
        return data.result;
      } 
      else {
        console.error('Server error:', data);
        return [];
      }
    } catch (error) {
      console.error('Network error:', error);
      return [];
    }
  } else {
    console.warn('Access token is not available.');
    return { form: 'Access token is missing.' };
  }
};

export const SaveJobSubcontractor = async (jobSubcontractor, navigate) => {
  const accesstoken = getToken();
  if (accesstoken) {
    try {
     let Payload = {
        jobSubcontractorID: jobSubcontractor.jobSubcontractorID || 0,
        jobID: jobSubcontractor.jobID || 0,
        skillID: jobSubcontractor.skillID || 0,
        employeeID: jobSubcontractor.employeeID || 0,
        teamID: jobSubcontractor.teamID || 0,
        unitID: jobSubcontractor.unitID,
        budgetedUnitQuantity: jobSubcontractor.budgetedUnitQuantity || 0,
        budgetedCostPerUnit: jobSubcontractor.budgetedCostPerUnit || 0,
        budgetedPricePerUnit: jobSubcontractor.budgetedPricePerUnit || 0,
        budgetedMarkup: jobSubcontractor.budgetedMarkup || 0,
        actualUnitQuantity: jobSubcontractor.actualUnitQuantity || 0,
        actualCostPerUnit: jobSubcontractor.actualCostPerUnit || 0,
        actualPricePerUnit: jobSubcontractor.actualPricePerUnit || 0,
        actualMarkup: jobSubcontractor.actualMarkup || 0,
        providedBy: jobSubcontractor.providedBy || 0,
        sortOrder: jobSubcontractor.sortOrder || 0,
        notes: jobSubcontractor.notes || ""
      };

      const response = await fetch(`${dev_baseUrl}/JobSubcontractor/save`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(Payload),
      });
      const data = await response.json();
      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
        navigate(`/login`);
      } else{
        return data;
      }
    } catch (error) {
      console.error('Network error:', error);
      return { isError:true, message: 'An error occurred. Please try again later.' , error: error};
    }
  } else {
    console.warn('Access token is not available.');
    return { form: 'Access token is missing.' };
  }
};

export const DeleteJobSubcontractor = async (jobSubcontractorID, jobID, navigate) => {
  const accesstoken = getToken();

  if (accesstoken) {
    try {
        const queryParams = new URLSearchParams({
            jobSubcontractorID,
            jobID
        }).toString();
        const response = await fetch(`${dev_baseUrl}/JobSubcontractor/delete?${queryParams}`, {
            method: 'DELETE',
            headers: {
            'Authorization': `Bearer ${accesstoken}`,
            'Content-Type': 'application/json',
            },
        });
      
        const data = await response.json();        

        if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
            navigate(`/login`);
        } else if(response.ok && !data.isError ){      
        return data;
        } 
        else {
        console.error('Server Error:',data.message);
        return data;
        }
    } catch (error) {
      console.error('Network error:', error);
      return { form: 'An error occurred. Please try again later.' };
    }
  } else {
    console.warn('Access token is not available.');
    return { form: 'Access token is missing.' };
  }
};